import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { NumericOperatorType} from "../../../../../../models/numeric-operator";
import {BaseFieldDeterminantComponent} from "./base-field-determinant.component";

@Component({
  selector: "date-determinant",
  templateUrl: "./date-determinant.component.html",
  styles: [],
})
export class DateDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public operator: NumericOperatorType;
  @Input() public isTargetComponent: boolean;
  @Input() public dateValue: Date;
  @Input() public isCurrentDate: boolean;
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;

  @Output() public dateValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();
  @Output() public isCurrentDateResponse = new EventEmitter();

  public ngOnInit() {
    this.operators = Object.keys(NumericOperatorType);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.dateValue && changes.dateValue.currentValue) {
      this.dateValue = new Date(changes.dateValue.currentValue);
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "datetime"));
    }
    super.ngOnChanges(changes);
  }

  public dateValueChanged(newValue: Date) {
    this.dateValueResponse.emit({dateValue: newValue});
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

  public isCurrentDateChanged() {
    this.isCurrentDateResponse.emit(this.isCurrentDate);
    this.dateValueResponse.emit(null);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.dateValueResponse.emit({sourceFormFieldKey: this.sourceFormFieldKey});
  }
}
